<template>
  <div class="setting-content--section">
    <TitleBar>
      <template v-slot:title>
        <span v-translate>Bank Connection</span>
      </template>
    </TitleBar>
    <div class="content">
      <b-tabs content-class="mt-3">
        <b-tab title="Bank Accounts" active>
          <h3>Selected Account: {{ selectedBankAccount.iban }}</h3>
          <div style="width:100%; display: flex;">
            <div>
              <table class="table">
                <tbody v-for="a_gekkobankaccount in gekko_bank_accounts" :key="a_gekkobankaccount.id">
                  <tr>
                    <td>{{ a_gekkobankaccount.iban }}</td>
                    <td><GekkoButton :text="$gettext('List Transactions')" type="button" @click="listTransactions(a_gekkobankaccount)" :disabled="a_gekkobankaccount.has_errors"></GekkoButton></td>
                  </tr>
                </tbody>
              </table>
              <hr />
              <div>Reimport</div>
              <b-form-group id="input-group-reimportdates" label-cols-sm="6" label-align-sm="right" content-cols-md="6" label-class="gk-label-margin" :label="$gettext('Date From')" label-for="input-reimportdates">
                <b-form-input id="input-reimportdates" v-model="reimport_date_start" :placeholder="$gettext('YYYY-MM-DD')"></b-form-input>
              </b-form-group>
              <b-form-group id="input-group-reimportdatee" label-cols-sm="6" label-align-sm="right" content-cols-md="6" label-class="gk-label-margin" :label="$gettext('Date To')" label-for="input-reimportdatee">
                <b-form-input id="input-reimportdatee" v-model="reimport_date_end" :placeholder="$gettext('YYYY-MM-DD')"></b-form-input>
              </b-form-group>
              <GekkoButton :text="$gettext('Reimport date')" type="button" @click="reimportDate"></GekkoButton>
              <div v-for="(a_importMessage, index) in importMessages" :key="index">{{ a_importMessage }}</div>
            </div>
            <div>
              <LoadingSpinner v-if="loading" />
              <table class="table">
                <tr>
                  <th>Time</th>
                  <th>External Id</th>
                  <th>Account Number</th>
                  <th>Description</th>
                  <th>Amount</th> 
                </tr>
                <tbody v-for="a_enablenowtransaction in transaction_list" :key="a_enablenowtransaction.id">
                  <tr>
                    <td>{{ a_enablenowtransaction.transactionDateTime }}</td>
                    <td>{{ a_enablenowtransaction.id }}</td>
                    <td>{{ a_enablenowtransaction.accountNumber }}</td>
                    <td>{{ a_enablenowtransaction.description }}</td>
                    <td>{{ a_enablenowtransaction.amount }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-tab>
        <b-tab title="Connection Details">
          Gekko
          <table class="table">
            <tbody v-for="a_gekkobankaccount in gekko_bank_accounts" :key="a_gekkobankaccount.id">
              <tr>
                <td>{{ a_gekkobankaccount.id }}</td>
                <td>{{ a_gekkobankaccount.iban }}</td>
                <td>{{ a_gekkobankaccount.bank_code }}</td>
                <td>{{ a_gekkobankaccount.external_consent_id }}</td>
                <td>{{ a_gekkobankaccount.provider }}</td>
              </tr>
            </tbody>
          </table>
          Enablenow
          <table class="table">
            <tbody v-for="a_consent in enablenow_consents" :key="a_consent.id">
              <tr>
                <td>CONSENT</td>
                <td>{{ a_consent.id }}</td>
                <td>{{ a_consent.status }}</td>
                <td>{{ a_consent.dateRequested }}</td>
                <td>{{ a_consent.dateExpire }}</td>
                <td>{{ a_consent.dateTransactionsUpdated }}</td>
                <td>{{ a_consent.providerKey }}</td>
              </tr>
              <tr v-for="a_bankaccount in a_consent.bank_accounts" :key="a_bankaccount.id">
                <td>ACCOUNT</td>
                <td>{{ a_bankaccount.id }}</td>
                <td>{{ a_bankaccount.iban }}</td>
                <td>{{ a_bankaccount.providerAccountId }}</td>
                <td>{{ a_bankaccount.accountHolder }}</td>
                <td>{{ a_bankaccount.bban }}</td>
                <td>{{ a_bankaccount.accountBalance.amount }}</td>
                <td>{{ a_bankaccount.accountBalance.date }}</td>
              </tr>
            </tbody>
          </table>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'


import TitleBar from "@/components/TitleBar";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"
import settingsPageSetup from '@/mixins/settingsPageSetup'
import GekkoButton from '@/components/GekkoButton'
import BankService from '@/store/services/bank.service'

export default {
  name: 'BankConnection',
  components: { GekkoButton, LoadingSpinner, TitleBar },
  mixins: [settingsPageSetup],
  data() {
    return {
      pageSettings: {
        title: this.$gettext('iDEAL Payments'),
        showCompanyPicker: true,
      },
      selectedBankAccount: {},
      enablenow_consents: [],
      enablenow_bank_accounts: [],
      transaction_list: [],
      gekko_bank_accounts: [],
      consent_id: null,
      iban: null,
      reimport_date_start: null,
      reimport_date_end: null,

      state: '',
      attach_mollie_payment: false,
      mollie: {},
      allProfiles: [],
      chosen_profile: null,
      external_id: null,

      is_staff: false,
      company_id: '',
      loading: false,
      importMessages: [],
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: 'main/getCurrentCompany',
      getCompanyId: 'main/getCompanyId'
    })
  },
  mounted() {
    // Band-aid fix for not being able to scroll
    document.body.classList.remove('modal-on')
  },
  created() {
    if (!this.currentCompany.accountant_branding.is_gekko_accountant) {
      this.$router.push({ name: 'Clients' })
    }
    this.company_id = this.getCompanyId
    BankService.listCompanyConsents({ company_profile: this.company_id }).then((response) => {
      this.enablenow_consents = response.data
    })
    BankService.listCompanyBankAccounts({ company_profile: this.company_id }).then((response) => {
      this.enablenow_bank_accounts = response.data
    })
    BankService.list({ company_profile: this.company_id, extended: true }).then((response) => {
      this.gekko_bank_accounts = response.data
      for (var i = 0; i < this.gekko_bank_accounts.length; i++) {
        this.gekko_bank_accounts[i].has_errors = true
        if(this.gekko_bank_accounts[i].external_consent_id != null && this.gekko_bank_accounts[i].iban != null){
          this.gekko_bank_accounts[i].has_errors = false
        }
      }
    })

    this.state = 'create'
  },
  methods: {
    listTransactions(gekkobankaccount) {
      this.selectedBankAccount = gekkobankaccount;
      this.loading = true;
      BankService.listTransactions({ consent_id: gekkobankaccount.external_consent_id, iban: gekkobankaccount.iban }).then((response) => {
        this.loading = false;
        this.transaction_list = response.data;
        this.importMessages = [];
      })
    },
    fetchConsentsForUser() {
      BankService.fetchConsentsForUser({external_user: this.external_id}).then((response) => {
        this.enablenow_consents = response.data;
      })
    },
    reimportDate() {
      if(this.selectedBankAccount.iban == null || this.selectedBankAccount.external_consent_id == null){
        alert("Select a bank account with a valid iban and valid consent_id")
        return
      }
      BankService.reimportOnDate({
        consent_id: this.selectedBankAccount.external_consent_id,
        iban: this.selectedBankAccount.iban,
        date_start: this.reimport_date_start,
        date_end: this.reimport_date_end,
      }).then((response) => {
        this.importMessages.push(this.reimport_date_start + " - " + this.reimport_date_end + ": Imported " + response.data)
        console.log(response.data)
      })
    }
  },
}
</script>

<style lang="scss" scoped>
img {
  max-width: 50%;
  height: auto;
}

p {
  white-space: pre-line;
  max-width: 90%;
}

.btn {
  white-space: nowrap;
  min-width: auto;
}

.fa-check {
  padding-right: 2.5rem;
}

.process-box__container {
  margin-top: 2rem;
  white-space: pre-line;
  max-width: 70%;

  .process-box {
    border-radius: 0.5rem;
    position: relative;
    border: 1px solid $colorLight;
  }

  .process-box__header {
    min-height: 1rem;
    display: flex;
    align-items: center;
    padding: 0.5rem 0.5rem;
    position: relative;
    line-height: 1;
    border-bottom: 1px solid $colorLight;
    flex-wrap: wrap;
    background-color: $colorBrand50;
  }

  .process-box__logo {
    max-width: 9rem;
    min-width: 5rem;
    padding: 0.25rem;
    display: inline-block;
  }

  .process-box__title {
    padding: 0 0.2rem 0 0.5rem;
    flex-shrink: 0;

    @media (max-width: 414px) {
      order: 2;
      margin-left: auto;
      width: 100%;
      padding: 1rem 0 0.5rem 0.2rem;
    }
  }

  .process-box__status {
    margin-left: auto;
    padding-right: 0.75rem;
    font-family: DINNextLTPro-Medium, sans-serif;
    font-size: 1.25rem;
    color: $colorDanger;
  }

  .process-box__status_inactive {
    color: $colorWarning;
  }

  .process-box__status_active {
    color: $colorBrand;
  }

  .stepper {
    display: flex;
    flex-flow: column nowrap;
  }

  .stepper__step {
    width: 100%;
    flex: 1 1 auto;
    display: flex;
  }

  .stepper__step--grayedout {
    color: $colorUnassigned;
  }

  .stepper__action {
    flex: 0 1 0;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 0.2rem;
    padding-right: 0.25rem;
    margin-left: auto;

    .btn {
      margin: 0.4rem 0.4rem;
    }
  }

  .stepper__action_first {
    padding-top: 0.6rem;
  }

  .stepper__details {
    flex: 1 1 auto;
    display: flex;
  }

  .stepper__text {
    padding: 0.4rem 0.2rem 0.75rem 0.5rem;
  }

  .stepper__text_first {
    padding-top: 0.8rem;
    padding-bottom: 1.75rem;
  }

  .stepper__header {
    font-size: 1.25rem;
    font-family: DINNextLTPro-Medium, sans-serif;
  }

  .stepper__subheader {
    font-size: 1rem;
    color: $colorTextSemi;
    margin-top: -0.1rem;
  }

  .timeline {
    min-width: 3rem;
    max-width: 3rem;
    display: flex;
    flex-flow: column nowrap;
    position: relative;
    align-items: center;
    padding-top: 0.3rem;
  }

  .timeline_first {
    padding-top: 1rem;
  }

  .timeline__symbol {
    position: relative;
    border: 2px solid $colorLight;
    border-radius: 100%;
    min-height: 2rem;
    max-height: 2rem;
    max-width: 2rem;
    min-width: 2rem;
    margin-bottom: 1px;
  }

  .timeline__number {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    line-height: 1;
    transform: translate(-50%, -50%);
    margin: 2px 0;
  }

  .timeline__vline {
    border-left: solid 1px $colorTextBase;
    flex: 1 0 auto;
    margin-top: 0.2rem;
    width: 1px;
  }

  .stepper__done {
    color: $colorBrand800;
    font-family: FontAwesome;
    font-size: 2rem;
  }

  .process-box__info {
    padding: 0.75rem 1rem 0.6rem 1rem;
    display: flex;
    flex-flow: column wrap;
  }

  .process-box__label {
    font-family: DINNextLTPro-Medium, sans-serif;
    color: $colorTextSemi;
    font-size: 1rem;
    padding-right: 0.6rem;
    margin: 0;
  }

  .process-box__value {
    color: $colorTextBase;
    font-size: 1rem;
    display: inline-block;
  }

  button.process-box__disconnect-btn {
    font-size: 1rem;
    color: $colorDanger;
  }

  .process-box__account-line,
  .process-box__status-line,
  .process-box__attach-line {
    padding-top: 0.4rem;
    display: inline-block;
  }

  .fa-ellipsis-vertical {
    color: $colorUnassigned;
  }
}

@media (max-width: 840px) {
  .process-box__container {
    max-width: 100%;
  }

  .process-box__content {
    .stepper__step {
      position: relative;
    }

    .stepper__action {
      position: absolute;
      bottom: 0;
      left: 3.3rem;
    }

    .stepper__text {
      padding-bottom: 3.75rem;
    }

    .stepper__step--grayedout {
      .stepper__text {
        padding-bottom: 2rem;
      }

      .stepper__action {
        left: 3.5rem;
      }
    }
  }
}
</style>